import { animations } from "./modules/animations";
import { header } from "./modules/header";
import { initPreloader } from "./modules/preloader";
import { handleFormSubmit } from "./modules/form";
import { tabs } from "./modules/tabs";
import { slider } from "./modules/slider";
import { triggerModal } from "./modules/modal";

document.addEventListener("DOMContentLoaded", function () {
  tabs();
  setTimeout(function () {
    animations().init();
  }, 1000);
  initPreloader();
  handleFormSubmit().init();
  header().init();
  slider().init();
  triggerModal();

  const formContainer = document.querySelector(".sk-form");
  formContainer.addEventListener("input", function (event) {
    const input = event.target.closest(".js-input");
    if (!input) return;
    const parent = input.closest(".sk-form__field");
    if (input.value.trim() !== "") {
      parent.classList.add("has-content");
    } else {
      parent.classList.remove("has-content");
    }
  });
});
